"use strict";
// Workaround to open issue with mapbox-gl here: https://github.com/mapbox/mapbox-gl-js/issues/9889
// This is needed to keep Jest happy and will not execute on the browser
if (typeof window !== 'undefined' && typeof window.URL.createObjectURL === 'undefined') {
    Object.defineProperty(window.URL, 'createObjectURL', { value: () => { } });
}
